import React from 'react';
import { motion } from 'framer-motion';

// TypeScript interface for process step data
export interface ProcessStep {
  number: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  duration: string;
  features: string[];
}

interface ProcessCardProps {
  step: ProcessStep;
  index: number;
  totalSteps: number;
}

const ProcessCard: React.FC<ProcessCardProps> = ({ 
  step, 
  index, 
  totalSteps
}) => {
  return (
    <div className="process-step-enhanced">
      <div className="step-indicator-enhanced">
        <div className="step-number-enhanced">
          <div className="icon-bg">
            <span className="step-icon">{step.icon}</span>
            <span className="step-num">{step.number}</span>
          </div>
        </div>
        {index < totalSteps - 1 && (
          <div className="step-connector">
            <div className="connector-line"></div>
            <div className="connector-dot"></div>
          </div>
        )}
      </div>
      
      <div className="step-content-enhanced">
        <div className="step-header">
          <h3 className="step-title">{step.title}</h3>
          <span className="step-duration">{step.duration}</span>
        </div>
        
        <p className="step-description">{step.description}</p>
        
        <div className="step-features">
          {step.features.map((feature, featureIndex) => (
            <span key={featureIndex} className="feature-tag">
              {feature}
            </span>
          ))}
        </div>
        
        <div className="step-progress">
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${(index + 1) * 20}%` }}
            />
          </div>
          <span className="progress-text">{index + 1} of {totalSteps}</span>
        </div>
      </div>
    </div>
  );
};

export default ProcessCard;
